export const impactStoryPath = (organizationId, impactStoryId) => {
  let path = `/${organizationId}/impact_stories`;
  if (impactStoryId) {
    path += `/${impactStoryId}`;
  }
  return path;
}
